module.exports = __webpack_public_path__ + "img/LNB_banner.df3b852c.svg";